import axios from "axios";


const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});


instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    config.headers.Authorization = `Bearer ${token}`;
    /* config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }; */
    return config;
})

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            window.location.replace('/');
        }

        return error.response;
    }
)

export default instance